import { NavLink } from "react-router";
import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import React from "react";
import { DeviceLoadManagementSidebarGroup } from "@/components/device-load-management-sidebar-group";

export const DevicesSidebar = ({
    ref,
    ...props
}: React.ComponentProps<"div"> & {
    side?: "left" | "right";
    variant?: "sidebar" | "floating" | "inset";
    collapsible?: "offcanvas" | "icon" | "none";
}) => {
    return (
        <Sidebar {...props} ref={ref}>
            {props.children}
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupLabel>Devices</SidebarGroupLabel>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            <SidebarMenuItem>
                                <SidebarMenuButton asChild>
                                    <NavLink
                                        className={"text-default-color"}
                                        to={`/devices`}
                                        end
                                    >
                                        <span>All devices</span>
                                    </NavLink>
                                </SidebarMenuButton>
                            </SidebarMenuItem>
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
                <DeviceLoadManagementSidebarGroup />
            </SidebarContent>
        </Sidebar>
    );
};
